export default __webpack_public_path__ + "static/media/getitongoogleplay.f902960a.png";